import { render, staticRenderFns } from "./rfp-form-create.vue?vue&type=template&id=76ae3d38&"
import script from "./rfp-form-create.vue?vue&type=script&lang=js&"
export * from "./rfp-form-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports